export const kitsTableColumns = [
  { id: 'kitNickname', label: 'Kit Nickname' },
  { id: 'totalQnty', label: 'Total Qty' },
  { id: 'viewDetailsButton', label: '' },
  { id: 'reorderButton', label: '' },
  { id: 'deleteButton', label: '' },
];

export const kitsTabs = [
  { label: 'My Kits', path: '/kits' },
  { label: 'Shared Marketing Kits', path: '/kits/shared' },
];

export const emptyKitsMessage =
  'There are currently no items saved in your kits';

export const emptyKitsButtonTitle = 'Go To Order History';
